// extracted by mini-css-extract-plugin
export default {"container":"usage_container__+9fC4","text":"usage_text__iBTDe","para":"usage_para__eBMdq","btn":"usage_btn__8LBcK","msg":"usage_msg__2hVjW"};